import moment from 'moment'
import Description from './Description'

const ChecklistHeader = ({ dispatch, ...props }) => {
	let language = props.language || {}

	return (
		<div className='row'>
			<div className='col-12'>
				<div className='col-12'>
					<div className='checklist-intro'>
						<ul className='checklist-invovled'>
							<li>
								<span>
									<b>
										{language.settings ? language.settings.employee : null}:
									</b>
								</span>
								<span>
									{' '}
									{props?.user?.first_name} {props?.user?.last_name}
								</span>
							</li>

							{props.employeeStores ? (
								<li>
									<span>
										<b>
											{language.manager_report
												? language.manager_report.stores
												: null}
											:{' '}
										</b>
									</span>
									<span>{props.employeeStores}</span>
								</li>
							) : null}

							{props.certifyTime ? (
								<li>
									<span>
										<b>
											{language.manager_report
												? language.manager_report.certified_date
												: null}
											:
										</b>
									</span>
									<span> {moment(props.certifyTime).format('MM/DD/YY')}</span>
								</li>
							) : null}

							{props.certifyTime ? (
								<li>
									<span>
										<b>
											{language.manager_report
												? language.manager_report.time
												: null}
											:
										</b>
									</span>
									<span>
										{' '}
										{props.certifyTime
											? moment(props.certifyTime).format('hh:mm')
											: ''}
									</span>
								</li>
							) : null}

							<li>
								<span>
									<b>
										{language.courses ? language.courses.validated_by : null}:
									</b>
								</span>
								<span> {props.managerName ? props.managerName : ''}</span>
							</li>
							<li>
								<span>
									<b>
										{language.courses ? language.courses.approved_by : null}:
									</b>
								</span>
								<span>
									{' '}
									{props.approvedBy
										? `${props.approvedBy.first_name}  ${props.approvedBy.last_name}`
										: ''}
								</span>
							</li>
						</ul>
						<Description {...props} />
					</div>
					{props.status === 'submit' ? (
						<div className='row checklist-footer-row'>
							<div className='col-12'>
								<button
									style={{ marginRight: '-12px' }}
									onClick={() => dispatch(props.resetChecklist())}
									className='btn btn-info py-1 px-4'
								>
									{language.general ? language.general.reset : null}
								</button>
							</div>
						</div>
					) : null}
				</div>
			</div>
		</div>
	)
}

export default ChecklistHeader
